"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezones = void 0;
var common_1 = require("../../schemas/common");
function getTimezones() {
    return Object.values(common_1.Timezone)
        .reduce(function (accumulator, value) {
        var index = accumulator.findIndex(function (s) { return s === value; });
        if (index === -1) {
            accumulator.push(value);
        }
        return accumulator;
    }, []);
}
exports.getTimezones = getTimezones;
